import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import type { SafeHtml } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';

import { ButtonComponent } from '@app/ui/components/button/button.component';

import { EventButtonComponent } from '../../../../shared/components';
import { AprilMadnessEventModalsService } from '../../../services';

@Component({
  selector: 'app-april-madness-faq-modal',
  templateUrl: './april-madness-faq-modal.component.html',
  styleUrl: './april-madness-faq-modal.component.scss',
  standalone: true,
  imports: [MatIcon, ButtonComponent, TranslatePipe, EventButtonComponent],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AprilMadnessFaqModalComponent {
  readonly #aprilMadnessEventModalsService = inject(AprilMadnessEventModalsService);
  readonly #sanitizer = inject(DomSanitizer);

  sanitize(text: string): SafeHtml {
    return this.#sanitizer.bypassSecurityTrustHtml(text);
  }

  onClose(): void {
    this.#aprilMadnessEventModalsService.closeFaqModal();
  }
}
